<div class="lg:grid" [ngClass]="{
 'grid-cols-12 gap-3 container md:my-md md:px-md md:py-md md:m-auto' : pageBuilderStore?.page?.layout === 'ltr' || pageBuilderStore?.page?.layout === 'rtl' || pageBuilderStore?.page?.layout === 'full',
 'gap-2' : pageBuilderStore?.page?.layout === 'full',
 'gap-3' : pageBuilderStore?.page?.layout === 'ltr' || pageBuilderStore?.page?.layout === 'rtl',

}">

        @if(pageBuilderStore?.page?.layout === 'ltr' || pageBuilderStore?.page?.layout === 'full'){
            <div class="col-span-4">
                <div cdkDropList
                     cdkDropListOrientation="vertical"
                     (cdkDropListDropped)="drop($event)">
                    @for(section of pageBuilderStore.page.sectionsLtr; track $index){
                        <white-label-section (removeSection)="removeSection(pageBuilderStore.page.sectionsLtr, $index)"  (addSection)="addNewSection($index, 'ltr')" [section]="section"  [index]="$index"></white-label-section>
                    }
                </div>

                <div (click)="addNewSection(pageBuilderStore.page.sectionsLtr.length, 'ltr')" class="w-full relative mt-5 h-72 cursor-pointer hover:bg-card-hover transition-all flex bg-card border border-gray-500 border-solid rounded-2xl p-4 items-center justify-center">
                    <div class="text-center text-gray-400">
                        <svg width="24" height="24" class="m-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="10" y="4" width="4" height="16" fill="currentColor"/>
                            <rect x="4" y="10" width="16" height="4" fill="currentColor"/>
                        </svg>
                        <h3 class="text-center text-2xl font-bold">{{ 'Add New Section' | translate }}</h3>
                    </div>
                </div>
            </div>
        }
        @if(pageBuilderStore?.page?.sections){

            <div [ngClass]="{
                'col-span-4': pageBuilderStore?.page?.layout === 'full',

                'col-span-8': pageBuilderStore?.page?.layout === 'ltr' ||  pageBuilderStore?.page?.layout === 'rtl'
            }">
                <div cdkDropList
                     cdkDropListOrientation="vertical"
                     (cdkDropListDropped)="drop($event)">
                    @for(section of pageBuilderStore.page.sections; track $index){
                        <white-label-section (removeSection)="removeSection(pageBuilderStore.page.sections, $index)"  (addSection)="addNewSection($event, 'middle')" [section]="section"  [index]="$index"></white-label-section>
                    }
                </div>

                <div (click)="addNewSection(pageBuilderStore.page.sections.length, 'middle')" class="w-full relative mt-5 h-72 cursor-pointer hover:bg-card-hover transition-all flex bg-card border border-gray-500 border-solid rounded-2xl p-4 items-center justify-center">
                    <div class="text-center text-gray-400">
                        <svg width="24" height="24" class="m-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="10" y="4" width="4" height="16" fill="currentColor"/>
                            <rect x="4" y="10" width="16" height="4" fill="currentColor"/>
                        </svg>
                        <h3 class="text-center text-2xl font-bold">{{ 'Add New Section' | translate }}</h3>
                    </div>
                </div>
            </div>
        }


        @if(pageBuilderStore?.page?.layout === 'rtl' || pageBuilderStore?.page?.layout === 'full'){
            <div class="col-span-4 my-2">
                <div cdkDropList
                     cdkDropListOrientation="vertical"
                     (cdkDropListDropped)="drop($event)">
                    @for(section of pageBuilderStore.page.sectionsRtl; track $index){
                        <white-label-section (removeSection)="removeSection(pageBuilderStore.page.sectionsRtl, $index)" [section]="section"  [index]="$index"></white-label-section>
                    }
                </div>

                <div (click)="addNewSection(pageBuilderStore.page.sectionsRtl.length, 'rtl')" class="w-full relative mt-5 h-72 cursor-pointer hover:bg-card-hover transition-all flex bg-card border border-gray-500 border-solid rounded-2xl p-4 items-center justify-center">
                    <div class="text-center text-gray-400">
                        <svg width="24" height="24" class="m-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="10" y="4" width="4" height="16" fill="currentColor"/>
                            <rect x="4" y="10" width="16" height="4" fill="currentColor"/>
                        </svg>
                        <h3 class="text-center text-2xl font-bold">{{ 'Add New Section' | translate }}</h3>
                    </div>
                </div>
            </div>
        }
</div>

<div  class="text-center mt-5">
    <app-button [text]="'save' | translate" (onClick)="savePage()"></app-button>
</div>


